import { Customer, Location, TruckingCompany } from '.';

export interface BookingDetails {
  id?: number | null;
  carb?: boolean | null;
  count?: number | null;
  received?: number | null;
  delivered?: number | null;
  reserved?: number | null;
  iso?: string[];
  // isoSize?: number | null;
}
export interface Booking {
  bookingDetails?: BookingDetails[] | null;
  bookingNumber?: string | null;
  bookingTemperature?: number | null;
  createdBy?: string | null;
  createdDate?: Date | number | string | null;
  customer?: Customer | null;
  customerCode?: string | null;
  customerFullName?: string | null;
  customerLocation?: string | null;
  customerName?: string | null;
  expirationDate?: Date | number | string | null;
  humidity?: number | null;
  id: number;
  lastUpdatedBy?: string | null;
  lastUpdatedDate?: Date | number | string | null;
  location?: Location | null;
  notes?: string | null;
  railyard?: string | null;
  requiresGenset?: boolean | null;
  startDate?: Date | number | string | null;
  truckingCompanies?: TruckingCompany[] | null;
  unitIds?: number[] | null;
  ventilation?: string | null;
  vesselLloydsNumber?: string | null;
  vesselName?: string | null;
  vesselVoyage?: string | null;
  sslScac?: string | null;
  fileExecutionId?: string;
  /* DTO FIELDS */
  count?: Readonly<number | null>;
  sizeType?: Readonly<string | null>;
  reserved?: Readonly<number | null>;
  received?: Readonly<number | null>;
  delivered?: Readonly<number | null>;
  anyTruckingCompany?: Readonly<boolean | null>;
}

export type RequiredBooking = Required<{ [P in keyof Booking]: NonNullable<Booking[P]> }>;

export interface Template {
  bookingDetails?: BookingDetails[] | null;
  bookingTemperature?: number | null;
  customer?: Customer | null;
  expirationDate?: Date | number | string | null;
  humidity?: number | null;
  id: number;
  location?: Location | null;
  name?: string | null;
  notes?: string | null;
  requiresGenset?: boolean | null;
  truckingCompanies?: TruckingCompany[] | null;
  ventilation?: string | null;
  vesselLloydsNumber?: string | null;
  vesselName?: string | null;
  vesselVoyage?: string | null;
  sslScac?: string | null;
}

export class CreatedBookingDetails implements BookingDetails {
  carb = false;
  id = null;
  iso: string[];
  // isoSize: number;
  count = 1;
  received = null;
  delivered = null;
  constructor(sizeType: string[]) {
    this.iso = sizeType;
    // this.isoSize = Number(sizeType.match(/[0-9]{2}/)?.[0]) || 0;
  }
}

export interface CreatedBooking {
  bookingNumber: string;
  bookingDetails: CreatedBookingDetails[];
  customer: Customer;
  expirationDate: string;
  location: Location;
  notes: string;
  startDate: string;
  truckingCompanies: TruckingCompany[];
  sslScac?: string;
}

export const sslScacs = [
  '11DX',
  '22AA',
  'ACLU',
  'ACSU',
  'AKMR',
  'ANNU',
  'ANRM',
  'APLU',
  'ARKU',
  'AROF',
  'BCLU',
  'CCMJ',
  'CEGL',
  'CHHK',
  'CHIW',
  'CHNJ',
  'CHVW',
  'CLIB',
  'CMCU',
  'CAMN',
  'CMDU',
  'CNIU',
  'COSU',
  'CPJQ',
  'CSVV',
  'DAAE',
  'DCSZ',
  'DOLQ',
  'EGLV',
  'EIMU',
  'EIMW',
  'EQLI',
  'ESPU',
  'EUKO',
  'FESO',
  'FLBP',
  'FLXZ',
  'FVIU',
  'GESC',
  'GFAL',
  'GMGO',
  'GRIU',
  'GSLU',
  'HDMU',
  'HJSC',
  'HLCU',
  'HRZD',
  'HRZU',
  'HTML',
  'HUAU',
  'HYDU',
  'IDMC',
  'IILU',
  'ILLU',
  'INOC',
  'IRSC',
  'KKLU',
  'KMTU',
  'KOSL',
  'LGLT',
  'LMCU',
  'MAEU',
  'MATS',
  'MCCQ',
  'MFTU',
  'MIOS',
  'MISC',
  'MOLU',
  'MRUB',
  'MSCU',
  'NCLL',
  'NIDU',
  'NODA',
  'NOSU',
  'NSAU',
  'NSHA',
  'NSLU',
  'NYKS',
  'ONEY',
  'OOLU',
  'PCIU',
  'PLLU',
  'PMOL',
  'POPZ',
  'PSHI',
  'RCKI',
  'RUNU',
  'SAFM',
  'SCIU',
  'SCYE',
  'SEAU',
  'SEFN',
  'SEJJ',
  'SENU',
  'SKII',
  'SKLU',
  'SLAQ',
  'SMLU',
  'SSLH',
  'SUDU',
  'THZS',
  'TOHO',
  'TOTE',
  'TPSP',
  'TRKU',
  'UALC',
  'UASU',
  'UBCU',
  'UNKN',
  'USLU',
  'WDLS',
  'WECU',
  'WHLC',
  'WLWH',
  'WWSU',
  'YMLU',
  'ZIMU'
];
